import React, { useState, useEffect } from 'react'
import { useStyles } from './HomeStudentStudyChoice_style'
import SchoolAPI from 'api/SchoolAPI'
import isEmpty from 'lodash.isempty'
import { Box } from '@material-ui/core'
import SectionSubTitle from 'components/SectionSubTitle/SectionSubTitle'
import ArticlesList from 'components/ArticlesList/ArticlesList'
import Button from 'shared/components/Button/Button.jsx'
import { FormattedMessage } from 'react-intl'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'

const HomeStudentStudyChoice = () => {
    const classes = useStyles()
    const [programArticles, setProgramArticles] = useState([])

    useEffect(() => {
        const data = { amount: 4 }

        SchoolAPI.GetSchoolProgramNews(data).then((response) => {
            setProgramArticles(response.data.program_articles)
        })
    }, [])

    if (isEmpty(programArticles)) return null

    return (
        <Box className={classes.articleSection}>
            <SectionSubTitle titleId='school_index.school_news.title' descriptionId='school_index.school_news.description'/>
            {programArticles &&
                <Box className={classes.articleBox}>
                    <ArticlesList articles={programArticles} />
                </Box>
            }
            <Box className={classes.showMoreButtonBox}>
                <RouteMapLink articleCategory='programs'>
                    <Button className={classes.showMoreButton}>
                        <FormattedMessage id='item_index.show_more_button' />
                    </Button>
                </RouteMapLink>
            </Box>
        </Box>
    )
}

export default HomeStudentStudyChoice
